// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;My tears have been my bread day and night,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;while all day long they say to me, &#145;Where is now your God?&#146;<br> </p> </div></div>";
// Exports
module.exports = code;